export default "__VITE_ASSET__752fc152__"